import { combineReducers } from 'redux';
import sharedReducer from './sharedReducer';
import userReducer from './userReducer';

export default combineReducers({
    sharedReducer,
    userReducer
});